import axios from "axios"
import { API_HOST } from "../BaseUrl"
import client, { headers } from "./config"
import { encrypt, generateHMAC } from "../../Utils/hmac"

export const simmetryImageUpload = async ({ formData }) => {
    const hmac = await generateHMAC()
    const updatedHeaders = {
        ...headers,
        'Content-Type': 'multipart/form-data',
        "X-Rt": hmac.timestamp,
        "X-Hmac": hmac.token
    }
    return new Promise(async (resolve, reject) => {
        try {
            const response = await axios.post(API_HOST + `simmetry/image/store`, formData, { headers: updatedHeaders })
            if (response.status === 200) {
                resolve(response)
            }
            reject(response.data)
        } catch (error) {
            reject(error)
        }
    })
}

export const submitSimmetryScan = async (data) => {
    const hmac = await generateHMAC()
    const _n = encrypt(data)
    const updatedHeader = {
        ...headers,
        "X-Rt": hmac.timestamp,
        "X-Hmac": hmac.token
    }
    return new Promise(async (resolve, reject) => {
        try {
            const response = await client.post(API_HOST + `ai/simmetry`, { _n }, { headers: updatedHeader })
            if (response.status === 200) {
                resolve(response)
            }
            reject(response)

        } catch (error) {
            reject(error)
        }
    })
}


export const submitSimUserDetails = async (data) => {
    const hmac = await generateHMAC()
    const updatedHeader = {
        ...headers,
        "X-Rt": hmac.timestamp,
        "X-Hmac": hmac.token
    }
    return new Promise(async (resolve, reject) => {
        try {
            const response = await client.post(API_HOST + `register-sim-user-details`, data, { headers: updatedHeader })
            if (response.status === 200) {
                resolve(response)
            }
            reject(response)

        } catch (error) {
            reject(error)
        }
    })
}

// get claraviewComboimages
export const getClaraviewComboimages = async (uid, imageName, isEmailed, email, is_consent_given) => {

    return new Promise(async (resolve, reject) => {
        try {
            const response = await client.get(API_HOST + `combo/${uid}/${imageName}/${localStorage.getItem("company")}`,
                { headers: { ...headers, isEmailed, email, isconsentgiven: is_consent_given } })
            if (response.status === 200) {
                resolve(response)
            }
            reject(response)

        } catch (error) {
            reject(error)
        }
    })
}
